import React, { useEffect, useState } from "react";
/** Component */
import { Paper, Grid, TextField, Autocomplete, Table, TableCell, TableContainer, TableHead, TableBody, TableRow, ButtonGroup } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";

/** Hook */
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";

/** API & Funtion */
import { setHeaderTitle } from "../../../store/layoutSlide";
import { getInvoiceForm, adjustInv } from "../../../services/api";
import { sumOfField, numberToStringVN, convertToMoneyWordEN, round } from "../../../services/libService";
import { TableFooter } from "@material-ui/core";

const inv_type = [
  { id: 2, label: "Điều chỉnh tăng" },
  { id: 3, label: "Điều chỉnh giảm" },
  { id: 4, label: "Điều chỉnh thông tin" },
];

const vat_type = [
  { id: 1, label: "Không chịu thuế", value: -1 },
  { id: 2, label: "Thuế 0%", value: 0 },
  { id: 3, label: "Thuế 5%", value: 5 },
  { id: 3, label: "Thuế 8%", value: 8 },
  { id: 3, label: "Thuế 10%", value: 10 },
];

const inf_error = [
  { id: 1, label: "Hóa đơn điện tử viết sai ngày, tháng, năm", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
  {
    id: 2,
    label: "Hóa đơn điện tử viết sai tên công ty",
    action: "Trường hợp hóa đơn đã lập có sai sót về tên, địa chỉ người mua nhưng ghi đúng MST người mua thì CHỈ CẦN lập biên bản điều chỉnh và KHÔNG CẦN lập hóa đơn điều chỉnh",
  },
  {
    id: 3,
    label: "Viết sai địa chỉ",
    action: "Trường hợp hóa đơn đã lập có sai sót về tên, địa chỉ người mua nhưng ghi đúng MST người mua thì CHỈ CẦN lập biên bản điều chỉnh và KHÔNG CẦN lập hóa đơn điều chỉnh",
  },
  { id: 4, label: "Viết sai mã số thuế", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
  { id: 5, label: "Viết sai tên hàng hoá", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
  { id: 6, label: "Hoá đơn điện tử viết sai số lượng", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
  { id: 7, label: "Hoá đơn điện tử viết sai đơn vị tính", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
  { id: 8, label: "Hoá đơn viết sai dòng số tiền bằng chữ", action: "Lập biên bản điều chỉnh và xuất hoá đơn điều chỉnh" },
];

const AdjustInv = () => {
  /** State */
  const [input, setInput] = useState({});
  const [invproduct, setInvProduct] = useState([]);
  /** Hook */
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    /** Init Input and invoiceproducts */
    setInput({
      /** Related invoice */
      e_id: location.state.id,
      e_fkey: location.state.fkey,
      e_serial: location.state.serial,
      e_form_no: location.state.form_no,
      e_code: location.state.code,
      e_date: location.state.valid_date,

      inv_type: 2,
      customer_id: location.state.customer_id,
      customer_address: location.state.customer_address,
      customer_name: location.state.customer_name,
      customer_tax: location.state.customer_tax,
      currency: location.state.currency,
      loadingtype_id: location.state.loadingtype_id,
      sub_amount: location.state.sub_amount,
      vat: location.state.vat,
      vat_rate: location.state.vat_rate,
      total: location.state.total,
      valid_date: moment().format("YYYY-MM-DD"),
      inwords: location.state.inwords,
    });

    if (location.state.invoiceproducts !== null) {
      location.state.invoiceproducts.map((item, id) =>
        invproduct.push({
          product_name: item.product_name,
          product_unit: item.product_unit,
          quantity: item.quantity,
          price_no: item.price_no,
          amount: item.amount,
        })
      );
    }

    console.log(location.state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setInput((prev) => ({ ...prev, invoiceproducts: invproduct, sub_amount: sumOfField(invproduct, "amount") }));
  }, [invproduct]);

  const _handleInWords = (currency, amount, type) => {
    if (currency === "VND") {
      switch (type) {
        case 2:
          return "Điều chỉnh tăng " + numberToStringVN(amount);
        case 3:
          return "Điều chỉnh giảm " + numberToStringVN(amount);
        default:
          return numberToStringVN(amount);
      }
    } else {
      switch (type) {
        case 2:
          return "Adjust amount up " + convertToMoneyWordEN(amount);
        case 3:
          return "Adjust amount down " + convertToMoneyWordEN(amount);
        default:
          return "";
      }
    }
  };

  useEffect(() => {
    /** If -1 do not need caculate */
    if (input.vat_rate === -1) {
      setInput((prev) => ({
        ...prev,
        total: input.sub_amount,
        inwords: _handleInWords(input.currency, input.sub_amount, input.inv_type),
      }));
    } else {
      setInput((prev) => ({
        ...prev,
        total:
          input.currency === "VND"
            ? input.sub_amount + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100)
            : input.sub_amount + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
        vat: input.currency === "VND" ? round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100) : round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
        inwords: _handleInWords(
          input.currency,
          input.currency === "VND"
            ? input.sub_amount + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100)
            : input.sub_amount + round((parseFloat(input.sub_amount) * parseFloat(input.vat_rate)) / 100, 2),
          input.inv_type
        ),
      }));
    }
  }, [input.currency, input.inv_type, input.sub_amount, input.vat, input.vat_rate]);

  /** Change value in invproduct array */
  const handleChange = (i, name, value) => {
    if (name === "price_no") {
      setInvProduct(invproduct.map((item, id) => (i !== id ? item : { ...item, [name]: value, amount: value * invproduct[i].quantity })));
    } else if (name === "quantity") {
      setInvProduct(invproduct.map((item, id) => (i !== id ? item : { ...item, [name]: value, amount: value * invproduct[i].price_no })));
    } else {
      setInvProduct(invproduct.map((item, id) => (i !== id ? item : { ...item, [name]: value })));
    }
  };

  const handleSubmit = () => {
    return adjustInv({ ...input, formno: input.form?.form, serial: input.form?.series });
  };

  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/invoices/${res.data?.id}?type=NAPR`);
  };

  /** Set Page Title */
  useEffect(() => {
    dispatch(setHeaderTitle("PHÁT HÀNH HOÁ ĐƠN ĐIỀU CHỈNH"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper styles={{ margin: 10 }}>
      <div align="left" style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 10, textTransform: "uppercase" }}>
        {"Thông tin hoá đơn bị điều chỉnh"}
      </div>
      <Grid container spacing={2} sx={{ margin: 3, width: "98%" }}>
        <Grid item xs={2}>
          <TextField fullWidth label={"Ký hiệu hoá đơn"} InputLabelProps={{ shrink: true }} value={input.e_form_no + "-" + input.e_serial} disabled />
        </Grid>

        <Grid item xs={2}>
          <TextField fullWidth label={"Ngày hoá đơn"} InputLabelProps={{ shrink: true }} value={moment(input.e_date).format("DD/MM/YYYY")} disabled />
        </Grid>
        <Grid item xs={2}>
          <TextField fullWidth label={"Số hoá đơn"} InputLabelProps={{ shrink: true }} value={input.e_code} disabled />
        </Grid>
      </Grid>

      <div align="left" style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 10, textTransform: "uppercase" }}>
        {"Thông tin hoá đơn điều chỉnh"}
      </div>
      <Grid container spacing={2} sx={{ margin: 3, width: "98%" }}>
        <Grid item xs={2}>
          <FilterBy
            getDataFunc={() => getInvoiceForm({ status: 1 })}
            value={input.form}
            getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, form: newValue, formno: newValue.form, serial: newValue.series }))}
            label={"Ký hiệu hóa đơn"}
            triggerSetDefaultFunc={Boolean(location.state)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, form: option.find((item) => item.form === location.state.form_no && item.series === location.state.serial) }))}
          />
        </Grid>
        <Grid item xs={2}>
          <CustomDatePicker
            format="DD/MM/YYYY"
            outputFormat="YYYY-MM-DD"
            label={"Ngày phát hành"}
            value={input.valid_date}
            onChange={(value) => setInput((prev) => ({ ...prev, valid_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            disableClearable
            options={inv_type}
            getOptionLabel={(option) => option.label}
            value={inv_type.find((item) => item.id === input.inv_type)}
            onChange={(e, newValue) => {
              if (newValue.id === 4) {
                setInput((prev) => ({
                  ...prev,
                  inv_type: newValue.id,
                  sub_amount: 0,
                  vat: 0,
                  total: 0,
                  invoiceproducts: invproduct.map((item) => ({
                    product_name: item.product_name,
                    product_unit: item.product_unit,
                    quantity: 0,
                    price_no: 0,
                    amount: 0,
                  })),
                }));
              } else {
                setInput((prev) => ({ ...prev, inv_type: newValue.id, invoiceproducts: invproduct }));
              }
            }}
            renderInput={(params) => <TextField {...params} label={"Loại hoá đơn điều chỉnh"} />}
          />
        </Grid>

        <Grid item xs={11}>
          <TextField fullWidth label={"Đơn vị mua hàng"} InputLabelProps={{ shrink: true }} value={input.customer_name} disabled />
        </Grid>
        <Grid item xs={3}>
          <TextField fullWidth label={"Mã số thuế"} InputLabelProps={{ shrink: true }} value={input.customer_tax} disabled />
        </Grid>
        <Grid item xs={8}>
          <TextField fullWidth label={"Địa chỉ"} InputLabelProps={{ shrink: true }} value={input.customer_address} disabled />
        </Grid>
        <Grid item xs={11}>
          <TextField fullWidth label={"Chi chú"} InputLabelProps={{ shrink: true }} value={input.note} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
      </Grid>

      <div>
        <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{"Thông tin hàng hóa"}</div>
        <TableContainer style={{ marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }} align="center">
                STT
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "30%" }} align="center">
                Tên hàng hoá, dịch vụ
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                Đơn vị tính
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                Số lượng
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }} align="center">
                Tiền tệ
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "15%" }} align="center">
                Đơn giá
              </TableCell>
              <TableCell style={{ border: "0.5px solid lightgray", width: "20%" }} align="center">
                Thành tiền
              </TableCell>
            </TableHead>
            <TableBody>
              {input?.invoiceproducts?.map((item, id) => (
                <TableRow key={id}>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }}>{id + 1}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "30%" }}>
                    <TextField fullWidth value={item.product_name} onChange={(e) => handleChange(id, "product_name", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField fullWidth value={item.product_unit} inputProps={{ style: { textAlign: "center" } }} onChange={(e) => handleChange(id, "product_unit", e.target.value)} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField
                      fullWidth
                      inputProps={{ style: { textAlign: "right" } }}
                      value={item.quantity ? Math.round(item.quantity).toLocaleString() : "0"}
                      onChange={(e) => handleChange(id, "quantity", e.target.value)}
                    />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "10%" }}>
                    <TextField disabled inputProps={{ style: { textAlign: "center" } }} fullWidth value={input.currency} />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "15%" }}>
                    <TextField
                      fullWidth
                      inputProps={{ style: { textAlign: "right" } }}
                      value={
                        input.currency === "VND"
                          ? Math.round(item.price_no || 0).toLocaleString("vi-VN")
                          : (item.price_no || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      }
                      onChange={(e) => handleChange(id, "price_no", e.target.value)}
                    />
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray", width: "20%" }}>
                    {input.currency === "VND"
                      ? Math.round(item.amount || 0).toLocaleString("vi-VN")
                      : (item.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer style={{ marginTop: 2, width: "80%" }}>
          <TableHead />
          <TableBody>
            <TableRow>
              <TableCell style={{ width: "20%" }} align="left">
                Cộng tiền hàng
              </TableCell>
              <TableCell style={{ width: "20%" }} align="left" />
              <TableCell style={{ width: "10%" }} align="left">
                {input.currency}
              </TableCell>
              <TableCell style={{ width: "30%" }} align="right">
                {input.currency === "VND"
                  ? Math.round(input.sub_amount || 0).toLocaleString("vi-VN")
                  : (input.sub_amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: "20%" }} align="left">
                Thuế suất GTGT
              </TableCell>
              <TableCell style={{ width: "30%" }} align="center">
                <Autocomplete
                  disableClearable
                  options={vat_type}
                  getOptionLabel={(option) => option.label}
                  value={vat_type.find((item) => item.value === input.vat_rate)}
                  onChange={(e, newValue) =>
                    setInput((prev) => ({
                      ...prev,
                      vat_rate: newValue.value,
                      vat: newValue.value !== -1 ? (input.sub_amount === 0 ? input.sub_amount : round((input.sub_amount * newValue.value) / 100, input.currency === "USD" ? 2 : 0)) : -1,
                    }))
                  }
                  renderInput={(params) => <TextField {...params} label={"Thuế GTGT"} />}
                />
              </TableCell>
              <TableCell style={{ width: "10%" }} align="left">
                {input.currency}
              </TableCell>
              <TableCell style={{ width: "30%" }} align="right">
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ style: { textAlign: "right" } }}
                  value={input.vat}
                  onChange={(e) => setInput((prev) => ({ ...prev, vat: e.target.value }))}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ width: "20%" }} align="left">
                Tổng tiền hàng
              </TableCell>
              <TableCell style={{ width: "20%" }} align="left" />
              <TableCell style={{ width: "10%" }} align="left">
                {input.currency}
              </TableCell>
              <TableCell style={{ width: "30%" }} align="right">
                {input.currency === "VND" ? Math.round(input.total || 0).toLocaleString("vi-VN") : (input.total || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={4} align="left">
                Số tiền viết bằng chữ: {input.inwords}
              </TableCell>
            </TableRow>
          </TableBody>
        </TableContainer>
      </div>

      {input.inv_type !== 4 && (
        <div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }} align="center">
                  STT
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "40%" }} align="center">
                  Lỗi sai trên hóa đơn không ảnh hưởng đến tiền
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", width: "50%" }} align="center">
                  Cách sử lý hoá đơn điều chỉnh
                </TableCell>
              </TableHead>
              <TableBody>
                {inf_error.map((item, id) => (
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray", width: "5%" }} align="center">
                      {item.id}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", width: "40%" }} align="left">
                      {item.label}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray", width: "55%" }} align="left">
                      {item.action}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableCell colSpan={3} align="left">
                  Nội dung ghi chú: Điều chỉnh của hoá đơn số…, ký hiệu…, ngày ..."Nội dung điều chỉnh từ ... thành ..."
                </TableCell>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
      )}

      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <ButtonWithAPICall style={{ margin: 2 }} variant="contained" api={handleSubmit} response={handleSubmitResponse}>
            {"Phát hành"}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
    </Paper>
  );
};

export default AdjustInv;
